import DOMPurify from 'dompurify';

export function sanitizeHtml(dirty: string): string {
  return DOMPurify.sanitize(dirty, {
    ALLOWED_TAGS: ['b', 'i', 'em', 'strong', 'span', 'br', 'p', 'a'],
    ALLOWED_ATTR: ['style', 'class', 'href', 'target', 'rel']
  });
}
